import { initGlobalMenu } from './modules/01_gnav';
import { pageTop, anchorLink } from './modules/02_smoothscroll';
import { initScrollHint } from './modules/03_scrollhint';
import { initLightboxWpBlockImage } from './modules/04_glightbox';

jQuery(function ($) {
  initGlobalMenu($);
  pageTop($);
});

// jQuery不要な処理は外で実行
anchorLink();
initScrollHint();
initLightboxWpBlockImage();
